<template>
  <div class="card p-4 bg-secondary-subtle text-center border-0">
    <h5 v-if="title" class="card-title fs-8 mb-2">{{ title }}</h5>
    <p v-if="subtitle" class="card-text fs-8">{{ subtitle }}</p>
    <slot></slot>
  </div>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    title?: string;
    subtitle?: string;
  }>(),
  { title: "", subtitle: "" }
);
</script>
